import * as Types from '../../../../../generated/types';

import { gql } from 'apollo-angular';
import { MutationDetailsAttributesFragmentDoc } from '../../../../contact/contact-form/graphql/contact.mutation.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ActivateElectronicInvoiceMutationVariables = Types.Exact<{
  action?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type ActivateElectronicInvoiceMutation = { __typename?: 'HyperionSchemaMutation', crediflowActivateParty?: { __typename?: 'Company', mutationDetails?: Array<{ __typename?: 'ModelErrorsTypeHyperionBase', argument?: string | null, errorsMsgs?: Array<string | null> | null, infoMsgs?: Array<string | null> | null, model?: string | null, modelErrorsMsgs?: Array<string | null> | null, modelSuccessMsgs?: Array<string | null> | null, modelWarningMsgs?: Array<string | null> | null, msg?: string | null, mutationSucceeded?: boolean | null, successMsgs?: Array<string | null> | null, warningMsgs?: Array<string | null> | null } | null> | null } | null };

export const ActivateElectronicInvoiceDocument = gql`
    mutation activateElectronicInvoice($action: String) {
  crediflowActivateParty(action: $action) {
    mutationDetails {
      ...MutationDetailsAttributes
    }
  }
}
    ${MutationDetailsAttributesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ActivateElectronicInvoiceGQL extends Apollo.Mutation<ActivateElectronicInvoiceMutation, ActivateElectronicInvoiceMutationVariables> {
    document = ActivateElectronicInvoiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }